import { createStyles, makeStyles } from '@mui/styles'

const useStyles = makeStyles(() =>
  createStyles({
    box: {
      height: '100%',
      paddingBottom: 10,
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'flex-start',
      marginBottom: 10,
      paddingRight: 13,
      '& > div': {
        fontWeight: 700,
        fontSize: 14,
        lineHeight: '140%',
        color: '#000',
        '&:nth-of-type(1)': {
          width: 110,
        },
        '&:nth-of-type(2)': {
          width: 70,
        },
        '&:nth-of-type(3)': {
          width: 100,
        },
        '&:nth-of-type(4)': {
          width: 80,
        },
        '&:nth-of-type(5)': {
          width: 70,
        },
        '&:nth-of-type(6)': {
          width: 75,
        },
        '&:nth-of-type(7)': {
          width: 60,
        },
        '&:nth-of-type(8)': {
          width: 80,
        },
        '&:nth-of-type(9)': {
          width: 70,
        },
        '&:nth-of-type(10)': {
          width: 95,
        },
        '&:nth-of-type(11)': {
          width: 65,
        },
      },
    },
    list: {
      position: 'relative',
      minHeight: 100,
      display: 'flex',
      flexDirection: 'column',
      gap: 0,
      overflowY: 'auto',
      maxHeight:
        'calc(var(--window-height) - 472px - 89px - 30px - 50px - var(--header-height) - var(--footer-height))',
      '&::-webkit-scrollbar': {
        width: 3,
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#1A0063',
      },
      '&::-webkit-scrollbar-track': {
        width: 3,
      },
      '&::-webkit-scrollbar-thumb:hover': {
        width: 10,
      },
    },
    empty: {
      textAlign: 'center',
      margin: 'auto',
      width: 'calc(100% - 13px)',
    },
    legend: {
      textAlign: 'right',
      margin: '10px 10px 0',
    },
  })
)
export default useStyles
